import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import {
  FaChevronDown,
  FaBars,
  FaTimes,
  FaRegQuestionCircle,
  FaBookOpen,
  FaTags,
  FaLayerGroup,
  FaEnvelopeOpenText,
  FaUserPlus,
} from "react-icons/fa";
import AuthButton, { useAuthStatus } from "../AuthButton/AuthButton";
import { dashboardUrl } from "../../config/app";
import mailsnappyLogo from "../../assets/logomail.png";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const isAuthenticated = useAuthStatus();
  const headerRef = useRef(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!openDropdown && !isMenuOpen) return;
      if (headerRef.current?.contains(event.target)) return;
      closeAll();
    };

    document.addEventListener("pointerdown", handleOutsideClick);
    return () => document.removeEventListener("pointerdown", handleOutsideClick);
  }, [openDropdown, isMenuOpen]);

  const handleDropdownToggle = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const closeAll = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  };

  return (
    <header ref={headerRef} className={`header ${isSticky ? "sticky" : ""}`}>
      <div className="header-container">
        <Link to="/" className="logo" onClick={closeAll} aria-label="Mailsnappy home">
          <img src={mailsnappyLogo} alt="Mailsnappy" />
        </Link>

        <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
          <div className={`dropdown ${openDropdown === "why" ? "open" : ""}`}>
            <button
              className="nav-link dropdown-toggle"
              onClick={() => handleDropdownToggle("why")}
              type="button"
            >
              <FaRegQuestionCircle className="nav-icon" />
              Why Mailsnappy
              <FaChevronDown className={`arrow ${openDropdown === "why" ? "rotate" : ""}`} />
            </button>
            <div className="dropdown-menu">
              <Link to="/features" onClick={closeAll}>Features</Link>
              <Link to="/about" onClick={closeAll}>About us</Link>
              <Link to="/grow-audience" onClick={closeAll}>Grow your audience</Link>
              <Link to="/automation" onClick={closeAll}>Automation</Link>
              <Link to="/analytics" onClick={closeAll}>Analytics</Link>
              <Link to="/mailchimp-alternative" onClick={closeAll}>Mailchimp Alternative</Link>
            </div>
          </div>

          <Link to="/templates" className="nav-link" onClick={closeAll}>
            <FaLayerGroup className="nav-icon" />
            Templates
          </Link>

          <Link to="/ai-template-designer" className="nav-link" onClick={closeAll}>
            <FaEnvelopeOpenText className="nav-icon" />
            AI Designer
          </Link>

          <Link to="/pricing" className="nav-link" onClick={closeAll}>
            <FaTags className="nav-icon" />
            Pricing
          </Link>

          <div className={`dropdown ${openDropdown === "resources" ? "open" : ""}`}>
            <button
              className="nav-link dropdown-toggle"
              onClick={() => handleDropdownToggle("resources")}
              type="button"
            >
              <FaBookOpen className="nav-icon" />
              Resources
              <FaChevronDown className={`arrow ${openDropdown === "resources" ? "rotate" : ""}`} />
            </button>
            <div className="dropdown-menu">
              <Link to="/guide" onClick={closeAll}>Email Marketing Guide</Link>
              <Link to="/blog" onClick={closeAll}>Blog</Link>
              <Link to="/templates" onClick={closeAll}>Template catalog</Link>
            </div>
          </div>

          <div className="header-auth-group mobile-only">
            <AuthButton authenticated={isAuthenticated} onNavigate={closeAll} />
            {!isAuthenticated && (
              <a href={dashboardUrl("/signup")} className="signup-header-btn" onClick={closeAll}>
                <FaUserPlus />
                <span>Signup</span>
              </a>
            )}
          </div>
        </nav>

        <div className="header-auth-group desktop-only">
          <AuthButton authenticated={isAuthenticated} />
          {!isAuthenticated && (
            <a href={dashboardUrl("/signup")} className="signup-header-btn">
              <FaUserPlus />
              <span>Signup</span>
            </a>
          )}
        </div>

        <button className="burger" onClick={toggleMenu} type="button" aria-label="Toggle menu">
          {isMenuOpen ? <FaTimes className="burger-icon" /> : <FaBars className="burger-icon" />}
        </button>
      </div>
    </header>
  );
};

export default Header;
